export default {
  'home.sectionTitle': 'Homepage',
  'home.menuTitle': 'Overview',
  'revenue.year.current': 'Current year',
  'revenue.year.past': 'Past year',
};
